import callIcon from "../assets/call-calling.png";
import mailIcon from "../assets/sms.png";
import locationIcon from "../assets/location.png";
import {
  aboutUrl,
  contactUrl,
  partnerUrl,
  productUrl,
  serviceUrl,
} from "./route";

export const footerDescription = (
  <>
    Manufacturer and Designer of smart Automation & Electronic Products. We
    <br /> write stack for MCU and as well as host, database server and API
    server in
    <br /> order to collect and store data. We also provide our clients with
    business
    <br /> and process optimization tools.
  </>
);

export const footerContactUsText = "Contact Us";
export const contactsMenu = [
  {
    name: "Tel",
    logoUrl: callIcon,
    value: "+91 98270 75240",
  },
  {
    name: "Mail",
    logoUrl: mailIcon,
    value: "support@cephlon.tech",
  },
  {
      number: "GSTIN 23AARFC5621L1Z9",
  },
  // {
  //   name: "",
  //   logoUrl:  Gst ,
  //   value: "GSTIN 23AARFC5621L1Z9",
  // },
];

export const shortsLinks = [
  {
    name: "Our Story",
    link: `${aboutUrl}?id=story`,
  },
  {
    name: "Our Services",
    link: serviceUrl,
  },
  {
    name: "Our Products",
    link: productUrl,
  },
  {
    name: "Contact Us",
    link: contactUrl,
  },
  {
    name: "Partner With Us",
    link: partnerUrl,
  },
  // {
  //   name: "FAQs",
  //   link: "#",
  // },
  // {
  //   name: "Site Map",
  //   link: "#",
  // },
];

export const otherLinks = [
  {
    name: "Our Clients",
    link: "#",
  },
  {
    name: "Clients Review",
    link: "/?id=clients",
  },
  {
    name: "Ongoing Customer",
    link: "#",
  },
  {
    name: "Customer Support",
    link: "#",
  },
  {
    name: "Ticketing",
    link: "#",
  },
  {
    name: "Call Center",
    link: "#",
  },
];

export const footerCopyrightsText = `© Cephlon Technology, All Right Reserved.`;
